export default __webpack_public_path__ + "static/media/files.56e071e6.svg";